module.exports = function() {
	return new Worker(__webpack_public_path__ + "a40e8413410242802a91.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./~/worker-loader!./src/logic/wordsAnalyzer.js
// module id = 483
// module chunks = 0